import { render, staticRenderFns } from "./CounselorContact.vue?vue&type=template&id=5ac9af96&scoped=true"
import script from "./CounselorContact.vue?vue&type=script&lang=js"
export * from "./CounselorContact.vue?vue&type=script&lang=js"
import style0 from "./CounselorContact.vue?vue&type=style&index=0&id=5ac9af96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac9af96",
  null
  
)

export default component.exports